import { saveEnvOverrides } from "./envManager";

export interface BackendEnvironment {
    id: string; // `cust-{prod|staging}-{us|eu}`
    displayName: string;
    appUrl: string; // WEBAPP_API_BASE_URL
    authUrl: string; // AUTH_URL
    apiUrl: string; // API_BASE_URL
}

export const VERA_ENVIRONMENTS: BackendEnvironment[] = [
    {
        id: "cust-prod-us",
        displayName: "United States",
        appUrl: "https://app.cust-prod-us.vera.icertis.com",
        authUrl: "https://auth.cust-prod-us.vera.icertis.com",
        apiUrl: "https://api.cust-prod-us.vera.icertis.com/api/v1",
    },
    {
        id: "cust-prod-eu",
        displayName: "Europe",
        appUrl: "https://app.cust-prod-eu.vera.icertis.com",
        authUrl: "https://auth.cust-prod-eu.vera.icertis.com",
        apiUrl: "https://api.cust-prod-eu.vera.icertis.com/api/v1",
    },
    {
        id: "cust-staging-us",
        displayName: "United States - Staging",
        appUrl: "https://app.cust-staging-us.vera.icertis.com",
        authUrl: "https://auth.cust-staging-us.vera.icertis.com",
        apiUrl: "https://api.cust-staging-us.vera.icertis.com/api/v1",
    },
    {
        id: "cust-staging-eu",
        displayName: "Europe - Staging",
        appUrl: "https://app.cust-staging-eu.vera.icertis.com",
        authUrl: "https://auth.cust-staging-eu.vera.icertis.com",
        apiUrl: "https://api.cust-staging-eu.vera.icertis.com/api/v1",
    },
];

export const findMatchingEnvironment = (
    overrides: Partial<Record<string, string>>
): string | null => {
    for (const env of VERA_ENVIRONMENTS) {
        if (
            env.appUrl === overrides.WEBAPP_API_BASE_URL &&
            env.authUrl === overrides.AUTH_URL &&
            env.apiUrl === overrides.API_BASE_URL
        ) {
            return env.id;
        }
    }
    return null;
};

function normalizeUrl(url: string): string {
    return url.trim().toLowerCase().replace(/\/+$/, "");
}

// WOPI: the platform returns one of our app URLs (e.g. https://app.cust-staging-us.vera.icertis.com/).
// Match it against the registry by appUrl — this doubles as an allowlist (unknown URL → null).
export function findEnvironmentByAppUrl(url: string): BackendEnvironment | null {
    const target = normalizeUrl(url);
    return VERA_ENVIRONMENTS.find((e) => normalizeUrl(e.appUrl) === target) ?? null;
}

export function applyEnvironment(env: BackendEnvironment): boolean {
    return saveEnvOverrides({
        WEBAPP_API_BASE_URL: env.appUrl,
        AUTH_URL: env.authUrl,
        API_BASE_URL: env.apiUrl,
    });
}
